<template>
<v-toolbar flat>
  <div class="text-center">

    <v-btn :disabled="count === 0" fab small v-shortkey="['ctrl'+'e']" @shortkey="excel()" @click="excel" class="ma-2 white--text" color="success">
      <v-icon dark>
        mdi-microsoft-excel
      </v-icon>
    </v-btn>

    <v-btn fab small v-shortkey="['esc']" @shortkey="back()" to="/" class="ma-2 white--text" color="info">
      <v-icon dark>
        mdi-logout-variant
      </v-icon>
    </v-btn>

  </div>
</v-toolbar>
</template>

<script>
//
export default {
  name: 'ReportButtons',
  data: () => ({}),
  props: ['count'],
  methods: {
    back() {
      this.$router.push(`/`)
    },
    excel() {
      this.$emit('excel')
    },
  },
}
</script>
